import React, { useEffect, useState } from 'react';
import { Card, List, Tag, Badge, Empty, Typography } from 'antd';
import { CarryOutOutlined, DownOutlined, RightOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { getWorkTasks } from '../../api/workTasks';
import { urgencyMeta } from '../../constants/agendaUrgency';
import useAuthStore from '../../store/authStore';

const { Text } = Typography;
const PAGE_SIZE = 5;
// /users/:id sadece MANAGER_ROLES icin acik (App.js) - bu widget ogretmen
// dashboard'unda da gorundugu icin isim sadece yonetici rolleri icin
// tiklanabilir gosteriliyor.
const CAN_VIEW_USER_DETAIL_ROLES = ['developer_admin', 'super_admin', 'branch_manager'];

const WorkTaskPendingPanel = () => {
  const navigate = useNavigate();
  const { user } = useAuthStore();
  const canViewUserDetail = CAN_VIEW_USER_DETAIL_ROLES.includes(user?.role);
  const [collapsed, setCollapsed] = useState(true);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({ current: 1, pageSize: PAGE_SIZE, total: 0 });

  const fetchItems = (page = 1) => {
    setLoading(true);
    getWorkTasks({
      filter: 'to_me',
      status: 'pending',
      sort_by: 'urgency',
      page,
      per_page: PAGE_SIZE,
    })
      .then((res) => {
        setItems(res.data.data);
        setPagination({
          current: res.data.current_page,
          pageSize: res.data.per_page,
          total: res.data.total,
        });
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  useEffect(() => { fetchItems(1); }, []);

  return (
    <Card
      size="small"
      title={
        <span
          className="cursor-pointer select-none flex items-center gap-2"
          onClick={() => setCollapsed((c) => !c)}
        >
          {collapsed ? <RightOutlined style={{ fontSize: 11, color: '#9ca3af' }} /> : <DownOutlined style={{ fontSize: 11, color: '#9ca3af' }} />}
          <CarryOutOutlined style={{ color: '#1677ff' }} />
          İş Takip — Bana Atanan Bekleyen İşler
          <Badge count={pagination.total} style={{ backgroundColor: pagination.total > 0 ? '#faad14' : '#d9d9d9' }} />
        </span>
      }
      style={{ marginBottom: 16 }}
    >
      {!collapsed && (
        <List
          size="small"
          loading={loading}
          dataSource={items}
          locale={{ emptyText: <Empty description="Bekleyen iş yok." image={Empty.PRESENTED_IMAGE_SIMPLE} /> }}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: pagination.total,
            size: 'small',
            hideOnSinglePage: true,
            onChange: (page) => fetchItems(page),
          }}
          renderItem={(item) => {
            const meta = urgencyMeta(item.urgency);
            return (
              <List.Item>
                <div className="w-full">
                  <div className="flex items-center gap-2 mb-0.5 flex-wrap">
                    <Tag color={meta.color} style={{ margin: 0 }}>{meta.label}</Tag>
                    <Text type="secondary" className="text-xs">
                      {item.assigned_by && canViewUserDetail ? (
                        <span
                          className="hover:underline cursor-pointer"
                          onClick={() => navigate(`/users/${item.assigned_by.id}`)}
                        >
                          {item.assigned_by.name} {item.assigned_by.surname}
                        </span>
                      ) : (
                        <>{item.assigned_by?.name} {item.assigned_by?.surname}</>
                      )} tarafından · {dayjs(item.created_at).format('DD.MM.YYYY HH:mm')}
                    </Text>
                  </div>
                  <div className="text-sm text-gray-700 mt-0.5" style={{ whiteSpace: 'pre-wrap' }}>
                    {item.description}
                  </div>
                </div>
              </List.Item>
            );
          }}
        />
      )}
    </Card>
  );
};

export default WorkTaskPendingPanel;
